import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Fieldset,
  Legend,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Collapse,
} from "reactstrap";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import Select from "../../../../../helpers/ui/CustomSelect";
import {
  FileInput,
  generateFormData,
} from "../../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect, withRouter } from "react-router-dom";
import apiResponse from "../../../../../services/apiResponse";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/cpnsService";
import CreateBloc from "../Blocs/CreateBloc";

class CreateModal extends Component {
  createBloc = new CreateBloc();
  timer;
  source;
  defaultSize = 10;

  constructor(props) {
    super(props);
    this.state = {
      dataForm: null,
      workUnitOption: [],
      positionOption: [],
      rankOption: [],
      educationOption: [],
      agamaGajiwebOption: [],
      satkerGajiwebOption: [],
      bankOption: [],
      empCategoriesOption: [],
      bankSpanGajiwebOption: [],
      // ensure employeeOption is an object so we can safely spread it
      employeeOption: {},
      // selectedSatker will hold the option object to pass to Select.value
      selectedSatker: null,
      birthNational: "Dalam Negeri",
      birthOptionCountry: [],
      birthOptionProvince: [],
      birthSelectedProvince: "",
      birthOptionCity: [],
      birthSelectedCityText: "",
      birthSelectedCity: "",
      birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
      bank_name: "",
      employee_categories_kode_kemenkeu: "",
      educationSelectedCode: "",
      rankSelectedCode: "",
      positionSelectedCode: "",
    };
  }

  // helper to find satker option by kdsatker (compare as strings)
  findSatkerOptionByKdsatker = (kdsatker) => {
    if (!kdsatker || !this.state.satkerGajiwebOption) return null;
    return (
      this.state.satkerGajiwebOption.find(
        (opt) => String(opt.value) === String(kdsatker),
      ) || null
    );
  };

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];

      return newObj;
    });
  };

  reformatAgamaOptions = (raw) => {
    if (!raw || !Array.isArray(raw)) {
      return [];
    }

    return raw.map((data) => ({
      label: `${data.kdagama} - ${data.agama}`,
      value: data.kdagama,
    }));
  };

  reformatSatkerOptions = (raw) => {
    if (!raw || !Array.isArray(raw)) {
      return [];
    }

    return raw.map((data) => ({
      label: `${data.kdsatker} - ${data.nmsatker}`,
      value: data.kdsatker,
    }));
  };

  reformatBankSpanOptions = (raw) => {
    if (!raw || !Array.isArray(raw)) {
      return [];
    }

    return raw.map((data) => ({
      label: `${data.kdbankspan} - ${data.nmbankspan}`,
      value: data.kdbankspan,
    }));
  };

  reformatEmpCategoriesOptions = (raw) => {
    if (!raw || !Array.isArray(raw)) {
      return [];
    }

    return raw.map((data) => ({
      label: `${data.employee_categories_kode_kemenkeu} - ${data.employee_categories_name}`,
      value: data.employee_categories_kode_kemenkeu,
    }));
  };

  handleBirthSelectNationality = (birthSelectNationality) => {
    let selected = birthSelectNationality.value;
    if (selected == "Dalam Negeri") {
      this.setState({
        birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3",
        birthNational: selected,
      });
    } else {
      this.setState({
        birthSelectedCountry: "",
        birthSelectedProvince: "",
        birthSelectedCity: "",
        birthNational: selected,
      });
    }
  };

  handleBirthSelectProvince = (birthSelectedProvince) => {
    let selected = birthSelectedProvince.value;
    this.getBirthCityByProvince(selected);
  };

  handleBirthSelectCity = (selectedCity) => {
    this.setState({
      birthSelectedCity: selectedCity.value,
      birthSelectedCityText: selectedCity.label,
    });
  };

  handleEducationSelect = (selectedEducation) => {
    this.setState({
      educationSelectedCode: selectedEducation.code,
    });
  };

  handleRankSelect = (selectedRank) => {
    this.setState({
      rankSelectedCode: selectedRank.code,
    });
  };

  handlePositionSelect = (selectedPosition) => {
    this.setState({
      positionSelectedCode: selectedPosition.code,
    });
  };

  getBirthCityByProvince = (province_uuid) => {
    this.setState({ birthSelectedCity: "" });
    this.createBloc.fetchRegionCity({
      is_local: 1,
      type: 3,
      parent_uuid: province_uuid,
    });
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        period_uuid: this.props.periodUuid,
        uuid: this.props.detailUuid,
        ...values,
      },
      confirm: true,
    });
  };

  loadEducation = async () => {
    this.setState({ loadingEducation: true });
    await this.createBloc.fetchEducation({ is_default: 1 });
  };

  loadRank = async () => {
    this.setState({ loadingRank: true });
    await this.createBloc.fetchRank();
  };

  loadWorkUnit = async () => {
    this.setState({ loadingWorkUnit: true });
    await this.createBloc.fetchWorkUnit();
  };

  loadAgamaGajiWeb = async () => {
    this.setState({ loadingAgamaGajiWeb: true });
    await this.createBloc.fetchAgamaGajiWeb();
  };

  loadSatkerGajiWeb = async () => {
    this.setState({ loadingSatkerGajiWeb: true });
    await this.createBloc.fetchSatkerGajiWeb();
  };

  loadBank = async () => {
    this.setState({ loadingBank: true });
    await this.createBloc.fetchBank();
  };

  loadBankSpanGajiWeb = async () => {
    this.setState({ loadingBankSpanGajiWeb: true });
    await this.createBloc.fetchBankSpanGajiWeb();
  };

  loadEmpCategories = async () => {
    this.setState({ loadingEmpCategories: true });
    await this.createBloc.fetchEmpCategories();
  };

  loadEmployee = async (nip) => {
    if (!nip) return;

    this.setState({ loadingEmployee: true });
    await this.createBloc.fetchEmployee({ nip });
  };

  loadPosition = async (uuid) => {
    this.setState({ loadingPosition: true });
    await this.createBloc.fetchPosition({
      is_internal: 1,
    });
  };

  loadRegionCountry = async (uuid) => {
    this.setState({ loadingRegionCountry: true });
    await this.createBloc.fetchRegionCountry({ type: 1 });
  };

  loadRegionProvince = async (uuid) => {
    this.setState({ loadingRegionProvince: true });
    await this.createBloc.fetchRegionProvince({ type: 2 });
  };

  loadDetail = async (uuid) => {
    const query = {
      uuid: uuid,
    };
    await this.createBloc.fetchDetailCandidate(query);
  };

  submitData = async () => {
    await this.createBloc.fetchCreate(this.state.dataForm);
    // if (this.props.uuid === '') {
    //     await this.createBloc.fetchCreate(this.state.dataForm)
    // } else {
    //     await this.createBloc.fetchCreateDetail(this.state.dataForm)
    // }
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadEducation();
    this.loadWorkUnit();
    this.loadAgamaGajiWeb();
    this.loadSatkerGajiWeb();
    this.loadBank();
    this.loadBankSpanGajiWeb();
    this.loadEmpCategories();
    this.loadPosition();
    this.loadRank();
    this.loadRegionCountry();
    this.loadRegionProvince();
  };

  componentDidMount() {
    this.setTokenAPI();

    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          //this.props.setUuid(result.data.response.employee_transfer_uuid)
          //this.createBloc.fetchCreateDetail({ ...this.state.dataForm, uuid: result.data.response.employee_transfer_uuid })
          this.setState({
            loading: false,
            success: true,
          });
          this.props.toggle();
          this.props.handleReload();
          this.props.setDetailUuid();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          this.props.toggle();
          this.props.handleReload();
          this.props.setDetailUuid();
          break;
        default:
          break;
      }
    });

    this.createBloc.detailCandidateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let resp = result.data.response;

          if (resp?.cpns_candidate_nip) {
            this.loadEmployee(resp.cpns_candidate_nip);
          }

          if (resp != null) {
            const selectedEducation = this.state.educationOption.find(
              (opt) => opt.value === resp.cpns_candidate_last_education_uuid,
            );

            const selectedRank = this.state.rankOption.find(
              (opt) => opt.value === resp.cpns_candidate_rank_uuid,
            );

            this.setState({
              loading: false,
              detail: resp,

              birthOptionCity: [
                {
                  label: resp.cpns_candidate_place_of_birth_city_name,
                  value: resp.cpns_candidate_place_of_birth_city_uuid,
                },
              ],
              birthNational: resp.cpns_candidate_place_of_birth_national,
              birthSelectedCountry:
                resp.cpns_candidate_place_of_birth_country_uuid,
              birthSelectedProvince:
                resp.cpns_candidate_place_of_birth_province_uuid,
              birthSelectedCity: resp.cpns_candidate_place_of_birth_city_uuid,
              birthSelectedCityText:
                resp.cpns_candidate_place_of_birth_city_name,
              educationSelectedCode: selectedEducation
                ? selectedEducation.code
                : "",
              rankSelectedCode: selectedRank ? selectedRank.code : "",
            });
          } else {
            this.setState({
              loading: false,
              detail: null,
              birthNational: "Dalam Negeri",
              birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3",
              birthSelectedProvince: "",
              birthSelectedCity: "",
              birthSelectedCityText: "",
              educationSelectedCode: "",
              rankSelectedCode: "",
            });
          }
          this.props.toggle();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.educationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            educationOption: result.data.response.result.map(function (data) {
              var newObj = {};
              newObj["label"] =
                `${data.education_kemenkeu_code} - ${data.education_name}`;
              newObj["value"] = data.education_uuid;
              newObj["code"] = data.education_kemenkeu_code;
              return newObj;
            }),
            loadingEducation: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.rankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            rankOption: result.data.response.result.map(function (data) {
              var newObj = {};
              newObj["label"] =
                `${data.rank_group_room} - ${data.rank_name} (${data.rank_group_room})`;
              newObj["value"] = data.rank_uuid;
              newObj["code"] = data.rank_group_room;
              return newObj;
            }),
            loadingRank: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            workUnitOption: this.reformatOptions(
              result.data.response.result,
              "work_unit_name_tabs",
              "work_unit_uuid",
            ),
            loadingWorkUnit: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.agamaGajiWebChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const agamaData = result?.data?.response?.data?.decryptData;

          this.setState({
            agamaGajiwebOption: agamaData
              ? this.reformatAgamaOptions(agamaData)
              : [],
            loadingAgamaGajiWeb: false,
          });
          break;

        case apiResponse.ERROR:
          this.setState({
            loadingAgamaGajiWeb: false,
          });
          break;

        default:
          break;
      }
    });

    this.createBloc.satkerGajiWebChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const satkerData = result?.data?.response?.data?.decryptData;

          // set options first, then if employeeOption has kdsatker, compute selectedSatker
          const options = satkerData
            ? this.reformatSatkerOptions(satkerData)
            : [];

          this.setState(
            {
              satkerGajiwebOption: options,
              loadingSatkerGajiWeb: false,
            },
            () => {
              const kds = this.state.employeeOption?.kdsatker;
              if (kds) {
                const selected = this.findSatkerOptionByKdsatker(kds);
                if (selected) this.setState({ selectedSatker: selected });
              }
            },
          );

          break;

        case apiResponse.ERROR:
          this.setState({
            loadingSatkerGajiWeb: false,
          });
          break;

        default:
          break;
      }
    });

    this.createBloc.bankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          console.log("Bank data:", result);

          const bankData = result?.data?.response?.result;

          this.setState({
            bankOption: bankData
              ? this.reformatOptions(bankData, "bank_name", "bank_name")
              : [],
            loadingBank: false,
          });
          break;

        case apiResponse.ERROR:
          console.error("Bank error:", result);
          this.setState({
            loadingBank: false,
          });
          break;

        default:
          break;
      }
    });

    this.createBloc.bankSpanGajiWebChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const bankSpanData = result?.data?.response?.data?.decryptData;

          this.setState({
            bankSpanGajiwebOption: bankSpanData
              ? this.reformatBankSpanOptions(bankSpanData)
              : [],
            loadingBankSpanGajiWeb: false,
          });
          break;

        case apiResponse.ERROR:
          this.setState({
            loadingBankSpanGajiWeb: false,
          });
          break;

        default:
          break;
      }
    });

    this.createBloc.empCategoriesChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const categoriesData = result?.data?.response?.result;

          this.setState({
            empCategoriesOption: categoriesData
              ? this.reformatEmpCategoriesOptions(categoriesData)
              : [],
            loadingEmpCategories: false,
          });
          break;

        case apiResponse.ERROR:
          console.error("Employee Categories error:", result);
          this.setState({
            loadingEmpCategories: false,
          });
          break;

        default:
          break;
      }
    });

    this.createBloc.employeeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const employeeData = result?.data?.response?.data?.decryptData?.[0];

          console.log("Employee data:", employeeData);

          // set employee data then, if satker options already loaded, compute selectedSatker
          this.setState(
            { employeeOption: employeeData || {}, loadingEmployee: false },
            () => {
              const kds = this.state.employeeOption?.kdsatker;
              if (kds && this.state.satkerGajiwebOption?.length) {
                const selected = this.findSatkerOptionByKdsatker(kds);
                if (selected) this.setState({ selectedSatker: selected });
              }
            },
          );

          break;

        case apiResponse.ERROR:
          console.error("Employee Categories error:", result);
          this.setState({
            loadingEmployee: false,
          });
          break;

        default:
          break;
      }
    });

    this.createBloc.positionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          // this.setState({
          //   positionOption: this.reformatOptions(
          //     result.data.response.result,
          //     "position_name",
          //     "position_uuid"
          //   ),
          //   loadingPosition: false,
          // });

          this.setState({
            positionOption: result.data.response.result.map(function (data) {
              var newObj = {};
              newObj["label"] =
                `${data.position_name}`;
              newObj["value"] = data.position_uuid;
              newObj["code"] = '00';
              return newObj;
            }),
            loadingPosition: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.regionCountryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            birthOptionCountry: this.reformatOptions(
              result.data.response.result,
              "region_name",
              "region_uuid",
            ),
            loadingRegion: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.regionProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            birthOptionProvince: this.reformatOptions(
              result.data.response.result,
              "region_name",
              "region_uuid",
            ),
            loadingRegion: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.regionCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            birthOptionCity: this.reformatOptions(
              result.data.response.result,
              "region_name",
              "region_uuid",
            ),
            loadingRegion: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
    this.createBloc.detailCandidateChannel?.unsubscribe();
    this.createBloc.educationChannel?.unsubscribe();
    this.createBloc.rankChannel?.unsubscribe();
    this.createBloc.workUnitChannel?.unsubscribe();
    this.createBloc.agamaGajiWebChannel?.unsubscribe();
    this.createBloc.satkerGajiWebChannel?.unsubscribe();
    this.createBloc.bankChannel?.unsubscribe();
    this.createBloc.bankSpanGajiWebChannel?.unsubscribe();
    this.createBloc.empCategoriesChannel?.unsubscribe();
    this.createBloc.employeeChannel?.unsubscribe();
    this.createBloc.positionChannel?.unsubscribe();
    this.createBloc.regionCountryChannel?.unsubscribe();
    this.createBloc.regionProvinceChannel?.unsubscribe();
    this.createBloc.regionCityChannel?.unsubscribe();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.modal !== this.props.modal) {
      if (this.props.modal == false) {
        this.setState({
          dataForm: null,
          detail: null,
          birthNational: "Dalam Negeri",
          birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3",
          birthSelectedProvince: "",
          birthSelectedCity: "",
          birthSelectedCityText: "",
          educationSelectedCode: "",
          rankSelectedCode: "",
        });
      }
    }

    if (prevProps.detailUuid !== this.props.detailUuid) {
      if (this.props.detailUuid) {
        this.loadDetail(this.props.detailUuid);
      }
    }
  }

  render() {
    const { employeeOption, satkerGajiwebOption } = this.state;

    return (
      <Fragment>
        <Modal isOpen={this.props.modal} size="xl" toggle={this.props.toggle}>
          <ModalHeader
            toggle={() => {
              this.props.toggle();
              this.props.setDetailUuid();
            }}
          >
            Input Anggota CPNS
          </ModalHeader>
          <ModalBody>
            <AvForm
              className="needs-validation"
              onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
            >
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Penetapan NIP BKN <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <AvField
                    name="cpns_bkn_confirmation_number"
                    placeholder="NIP BKN"
                    errorMessage="Masukkan NIP BKN"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cpns_bkn_confirmation_number}
                    validate={{
                      required: { value: true },
                      // minLength: {
                      //   value: 18,
                      //   errorMessage: "Minimum NIP 18 digits",
                      // },
                      // maxLength: {
                      //   value: 18,
                      //   errorMessage: "Maximum NIP 18 digits",
                      // },
                      // pattern: {
                      //   value: /^[0-9]+$/,
                      //   errorMessage: "Please enter only numbers",
                      // },
                    }}
                  />
                </Col>
                <Col md="3">
                  <AvField
                    name="cpns_bkn_confirmation_date"
                    placeholder="Tanggal"
                    errorMessage="Masukkan Tanggal"
                    type="date"
                    className="form-control"
                    value={this.state.detail?.cpns_bkn_confirmation_date}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <hr />

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Nama<span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_name"
                    placeholder="Nama"
                    errorMessage="Masukkan Nama"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cpns_candidate_name}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Gelar (Depan | Belakang)
                </Label>
                <Col md="2">
                  <AvField
                    name="cpns_candidate_front_title"
                    placeholder="Gelar Depan"
                    errorMessage="Masukkan Gelar Depan"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cpns_candidate_front_title}
                    validate={{ required: { value: false } }}
                  />
                </Col>
                <Col md="2">
                  <AvField
                    name="cpns_candidate_end_title"
                    placeholder="Gelar Belakang"
                    errorMessage="Masukkan Gelar Belakang"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cpns_candidate_end_title}
                    validate={{ required: { value: false } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  NIP<span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_nip"
                    placeholder="NIP"
                    errorMessage="Masukkan NIP"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cpns_candidate_nip}
                    validate={{
                      required: { value: true },
                      minLength: {
                        value: 18,
                        errorMessage: "Minimum NIP 18 digits",
                      },
                      maxLength: {
                        value: 18,
                        errorMessage: "Maximum NIP 18 digits",
                      },
                    }}
                  />
                </Col>
              </Row>

              {/* Satker */}
              {/* <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Satker <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <Select
                    name="cpns_candidate_satker"
                    placeholder="Pilih Satker"
                    options={satkerGajiwebOption}
                    defaultValue={
                      employeeOption?.kdsatker ||
                      (this.state.selectedSatker &&
                        this.state.selectedSatker.value)
                    }
                    onChange={(opt) =>
                      this.setState((prev) => ({
                        employeeOption: {
                          ...(prev.employeeOption || {}),
                          kdsatker: opt?.value,
                        },
                        selectedSatker: opt || null,
                      }))
                    }
                    key={String(
                      this.state.employeeOption?.kdsatker || "satker_select"
                    )}
                  />
                </Col>
              </Row> */}

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Tempat Lahir <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <Select
                    name="cpns_candidate_place_of_birth_national"
                    errorMessage="Pilih Dalam / Luar Negeri"
                    placeholder="Pilih Dalam / Luar Negeri"
                    options={[
                      { label: "Dalam Negeri", value: "Dalam Negeri" },
                      { label: "Luar Negeri", value: "Luar Negeri" },
                    ]}
                    onChange={this.handleBirthSelectNationality}
                    defaultValue={this.state.birthNational}
                    validate={{ required: { value: true } }}
                  />
                </Col>
                <Col md="3">
                  <Select
                    name="cpns_candidate_place_of_birth_country_uuid"
                    errorMessage="Negara"
                    placeholder="Negara"
                    options={this.state.birthOptionCountry}
                    onChange={(opt) =>
                      this.setState({ birthSelectedCountry: opt.value })
                    }
                    defaultValue={this.state.birthSelectedCountry}
                    validate={{ required: { value: true } }}
                    isDisabled={
                      this.state.birthNational == "Dalam Negeri" ? true : false
                    }
                  />
                </Col>
              </Row>

              <Row
                className="mb-3"
                style={
                  this.state.birthNational == "Dalam Negeri"
                    ? {}
                    : { display: "none" }
                }
              >
                <Label className="col-md-3 col-form-label"></Label>
                <Col md="3">
                  <Select
                    name="cpns_candidate_place_of_birth_province_uuid"
                    errorMessage="Provinsi"
                    placeholder="Provinsi"
                    options={this.state.birthOptionProvince}
                    onChange={this.handleBirthSelectProvince}
                    defaultValue={this.state.birthSelectedProvince}
                    validate={{
                      required: {
                        value:
                          this.state.birthNational == "Dalam Negeri"
                            ? true
                            : false,
                      },
                    }}
                  />
                </Col>
                <Col md="3">
                  <Select
                    name="cpns_candidate_place_of_birth_city_uuid"
                    errorMessage="Kota"
                    placeholder="Kota"
                    options={this.state.birthOptionCity}
                    onChange={this.handleBirthSelectCity}
                    value={this.state.birthOptionCity.find(
                      (opt) => opt.value === this.state.birthSelectedCity,
                    )}
                    validate={{
                      required: {
                        value:
                          this.state.birthNational == "Dalam Negeri"
                            ? true
                            : false,
                      },
                    }}
                  />
                  {/* Hidden field untuk UUID */}
                  <AvField
                    name="cpns_candidate_place_of_birth_city_uuid"
                    type="hidden"
                    value={this.state.birthSelectedCity}
                  />
                  {/* Hidden field untuk Text */}
                  <AvField
                    name="cpns_candidate_place_of_birth_city_text"
                    type="hidden"
                    value={
                      this.state.birthSelectedCityText ||
                      this.state.detail?.cpns_candidate_place_of_birth_city_text
                    }
                  />
                </Col>
              </Row>

              <Row
                className="mb-3"
                style={
                  this.state.birthNational == "Dalam Negeri"
                    ? { display: "none" }
                    : {}
                }
              >
                <Label className="col-md-3 col-form-label"></Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_place_of_birth_city_text"
                    placeholder="Kota..."
                    type="text"
                    errorMessage="Masukkan Kota"
                    className="form-control"
                    // controlled by state so edits persist and submission includes value
                    value={
                      this.state.birthSelectedCityText ||
                      this.state.detail
                        ?.cpns_candidate_place_of_birth_city_text ||
                      ""
                    }
                    onChange={(e) =>
                      this.setState({ birthSelectedCityText: e.target.value })
                    }
                    validate={{
                      required: {
                        value:
                          this.state.birthNational == "Dalam Negeri"
                            ? false
                            : true,
                      },
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Tanggal Lahir<span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <AvField
                    name="cpns_candidate_date_of_birth"
                    placeholder="Tanggal Lahir"
                    errorMessage="Masukkan Tanggal Lahir"
                    type="date"
                    className="form-control"
                    value={this.state.detail?.cpns_candidate_date_of_birth}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              {/* alamat */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Alamat<span className="text-danger"> *</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_adress"
                    placeholder="Masukkan Alamat"
                    errorMessage="Masukkan Alamat"
                    type="textarea"
                    className="form-control"
                    value={this.state.employeeOption?.alamat}
                    rows="3"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Alamat wajib diisi",
                      },
                    }}
                  />
                </Col>
              </Row>

              {/* Jenis Kelamin */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Jenis Kelamin <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <Select
                    name="cpns_candidate_gender"
                    errorMessage="Pilih Jenis Kelamin"
                    placeholder="Pilih Jenis Kelamin"
                    options={[
                      { label: "Laki-laki", value: "L" },
                      { label: "Perempuan", value: "P" },
                    ]}
                    onChange={(opt) => this.setState({ type: opt.value })}
                    defaultValue={this.state.detail?.cpns_candidate_gender}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              {/* Agama */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Agama <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <Select
                    name="cpns_candidate_religion"
                    errorMessage="Pilih Agama"
                    placeholder="Pilih Agama"
                    options={this.state.agamaGajiwebOption}
                    // prefer employeeOption.kdagama (e.g. "1") so the matching option ("1 - Islam") is auto-selected
                    defaultValue={
                      this.state.employeeOption?.kdagama ||
                      this.state.detail?.cpns_candidate_religion
                    }
                    onChange={(opt) =>
                      this.setState((prev) => ({
                        employeeOption: {
                          ...(prev.employeeOption || {}),
                          kdagama: opt?.value,
                        },
                      }))
                    }
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              {/* NPWP */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  NPWP<span className="text-danger"></span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_npwp"
                    placeholder="Masukkan NPWP"
                    errorMessage="Masukkan NPWP"
                    type="text"
                    className="form-control"
                    value={this.state.employeeOption?.npwp}
                  />
                </Col>
              </Row>

              {/* Kode Pos */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Kode Pos<span className="text-danger"> *</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_postal_code"
                    placeholder="Masukkan Kode Pos"
                    errorMessage="Masukkan Kode Pos"
                    type="number"
                    className="form-control"
                    value={this.state.employeeOption?.kdpos}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Kode Pos wajib diisi",
                      },
                      pattern: {
                        value: "^[0-9]+$",
                        errorMessage: "Hanya angka yang diperbolehkan",
                      },
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Pendidikan Terakhir <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <Select
                    name="cpns_candidate_last_education_uuid"
                    errorMessage="Pilih Pendidikan Terakhir"
                    placeholder="Pilih Pendidikan Terakhir"
                    options={this.state.educationOption}
                    onChange={this.handleEducationSelect}
                    value={this.state.educationOption.find(
                      (opt) =>
                        opt.value ===
                        this.state.detail?.cpns_candidate_last_education_uuid,
                    )}
                    validate={{ required: { value: true } }}
                  />

                  <AvField
                    name="cpns_candidate_last_education_uuid"
                    type="hidden"
                    value={
                      this.state.detail?.cpns_candidate_last_education_uuid
                    }
                  />
                  <AvField
                    name="cpns_candidate_last_education_code"
                    type="hidden"
                    value={this.state.educationSelectedCode}
                  />
                </Col>
                <Col md="3">
                  <AvField
                    name="cpns_candidate_last_education_major"
                    placeholder="Program Studi / Jurusan"
                    errorMessage="Masukkan Program Studi"
                    type="text"
                    className="form-control"
                    value={
                      this.state.detail?.cpns_candidate_last_education_major
                    }
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Pangkat <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <Select
                    name="cpns_candidate_rank_uuid"
                    errorMessage="Pilih Pangkat"
                    placeholder="Pilih Pangkat"
                    options={this.state.rankOption}
                    onChange={this.handleRankSelect}
                    value={this.state.rankOption.find(
                      (opt) =>
                        opt.value ===
                        this.state.detail?.cpns_candidate_rank_uuid,
                    )}
                    validate={{ required: { value: true } }}
                  />
                  {/* Hidden field untuk UUID */}
                  <AvField
                    name="cpns_candidate_rank_uuid"
                    type="hidden"
                    value={this.state.detail?.cpns_candidate_rank_uuid}
                  />
                  {/* Hidden field untuk Code */}
                  <AvField
                    name="cpns_candidate_rank_code"
                    type="hidden"
                    value={this.state.rankSelectedCode}
                  />
                </Col>
              </Row>

              {/* <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Jabatan <span className="text-danger">*</span>
                </Label>
                <Col md="6">
                  <Select
                    name="cpns_candidate_position_uuid"
                    errorMessage="Pilih Jabatan"
                    placeholder="Pilih Jabatan"
                    options={this.state.positionOption}
                    onChange={(opt) => this.setState({ type: opt.value })}
                    defaultValue={
                      this.state.detail?.cpns_candidate_position_uuid
                    }
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row> */}

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Jabatan <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <Select
                    name="cpns_candidate_position_uuid"
                    errorMessage="Pilih Jabatan"
                    placeholder="Pilih Jabatan"
                    options={this.state.positionOption}
                    onChange={this.handlePositionSelect}
                    value={this.state.positionOption.find(
                      (opt) =>
                        opt.value ===
                        this.state.detail?.cpns_candidate_position_uuid,
                    )}
                    validate={{ required: { value: true } }}
                  />
                  {/* Hidden field untuk UUID */}
                  <AvField
                    name="cpns_candidate_position_uuid"
                    type="hidden"
                    value={this.state.detail?.cpns_candidate_position_uuid}
                  />
                  {/* Hidden field untuk Code */}
                  <AvField
                    name="cpns_candidate_position_code"
                    type="hidden"
                    value={this.state.positionSelectedCode}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Unit Kerja <span className="text-danger">*</span>
                </Label>
                <Col md="6">
                  <Select
                    name="cpns_candidate_work_unit_uuid"
                    errorMessage="Pilih Unit Kerja"
                    placeholder="Pilih Unit Kerja"
                    options={this.state.workUnitOption}
                    onChange={(opt) => this.setState({ type: opt.value })}
                    defaultValue={
                      this.state.detail?.cpns_candidate_work_unit_uuid
                    }
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Enroll Number<span className="text-danger">*</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_enroll_number"
                    placeholder="Enroll Number"
                    errorMessage="Masukkan Enroll Number"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cpns_candidate_enroll_number}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              {/* Email Internal */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Email<span className="text-danger"> *</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_email_int"
                    placeholder="Masukkan Email"
                    errorMessage="Masukkan Email"
                    type="text"
                    className="form-control"
                    value={this.state.employeeOption?.email}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              {/* Email Eksternal */}
              {/* <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Email Eksternal<span className="text-danger"></span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_email_eks"
                    placeholder="Masukkan Email Eksternal"
                    errorMessage="Masukkan Email Eksternal"
                    type="text"
                    className="form-control"
                    value={this.state.detail?.cpns_candidate_email_eks}
                  />
                </Col>
              </Row> */}

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  No Telepon<span className="text-danger"> *</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_notelp"
                    placeholder="Masukkan No Telepon"
                    errorMessage="Masukkan No Telepon"
                    type="number"
                    className="form-control"
                    value={this.state.employeeOption?.notelp}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "No Telepon wajib diisi",
                      },
                      pattern: {
                        value: "^[0-9]+$",
                        errorMessage: "Hanya angka yang diperbolehkan",
                      },
                    }}
                  />
                </Col>
              </Row>

              {/* Bank */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Bank <span className="text-danger"></span>
                </Label>
                <Col md="3">
                  <Select
                    name="cpns_candidate_bank"
                    errorMessage="Pilih Bank"
                    placeholder="Pilih Bank"
                    options={this.state.bankOption}
                    // use employeeOption.nm_bank (e.g. "BANK MANDIRI") so select auto-chooses
                    defaultValue={
                      this.state.employeeOption?.nm_bank ||
                      this.state.detail?.cpns_candidate_bank
                    }
                    onChange={(opt) =>
                      this.setState((prev) => ({
                        employeeOption: {
                          ...(prev.employeeOption || {}),
                          nm_bank: opt?.value,
                        },
                        bank_name: opt?.value,
                      }))
                    }
                    isLoading={this.state.loadingBank}
                  />
                </Col>
              </Row>

              {/* Rekening */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Rekening<span className="text-danger"></span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_rekening_number"
                    placeholder="Masukkan Rekening"
                    errorMessage="Masukkan Rekening"
                    type="number"
                    className="form-control"
                    value={this.state.employeeOption?.rekening}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Rekening wajib diisi",
                      },
                      pattern: {
                        value: "^[0-9]+$",
                        errorMessage: "Hanya angka yang diperbolehkan",
                      },
                    }}
                  />
                </Col>
              </Row>

              {/* Pemilik Rekening */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Nama Pemilik Rekening<span className="text-danger"></span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_rekening_name"
                    placeholder="Masukkan Nama Pemilik Rekening"
                    errorMessage="Masukkan Nama Pemilik Rekening"
                    type="text"
                    className="form-control"
                    value={this.state.employeeOption?.nmrek}
                  />
                </Col>
              </Row>

              {/* Bank SPAN */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Bank SPAN <span className="text-danger"></span>
                </Label>
                <Col md="3">
                  <Select
                    name="cpns_candidate_bkspan"
                    errorMessage="Pilih Bank SPAN"
                    placeholder="Pilih Bank SPAN"
                    options={this.state.bankSpanGajiwebOption}
                    defaultValue={
                      this.state.employeeOption?.kdbankspan ||
                      this.state.detail?.cpns_candidate_bkspan
                    }
                    onChange={(opt) =>
                      this.setState((prev) => ({
                        employeeOption: {
                          ...(prev.employeeOption || {}),
                          kdbankspan: opt?.value,
                        },
                        kdbankspan: opt?.value,
                      }))
                    }
                  />
                </Col>
              </Row>

              {/* Honorer */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Honorer <span className="text-danger"></span>
                </Label>
                <Col md="3">
                  <Select
                    name="cpns_candidate_honorer"
                    errorMessage="Pilih Honorer"
                    placeholder="Dari Honorer atau Bukan"
                    options={[
                      { label: "Ya", value: 1 },
                      { label: "Tidak", value: 2 },
                    ]}
                    defaultValue={
                      this.state.employeeOption?.honorer ||
                      this.state.detail?.cpns_candidate_honorer
                    }
                    onChange={(opt) =>
                      this.setState((prev) => ({
                        employeeOption: {
                          ...(prev.employeeOption || {}),
                          honorer: opt?.value,
                        },
                      }))
                    }
                  />
                </Col>
              </Row>

              {/* Jenis pns */}
              {/* <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Jenis Pegawai <span className="text-danger">*</span>
                </Label>
                <Col md="3">
                  <Select
                    name="cpns_candidate_jpns"
                    errorMessage="Pilih Jenis Pegawai"
                    placeholder="Pilih Jenis Pegawai"
                    options={this.state.empCategoriesOption}
                    defaultValue={
                      this.state.employeeOption?.jpns ||
                      this.state.detail?.cpns_candidate_jpns
                    }
                    onChange={(opt) =>
                      this.setState((prev) => ({
                        employeeOption: {
                          ...(prev.employeeOption || {}),
                          jpns: opt?.value,
                        },
                        employee_categories_kode_kemenkeu: opt?.value,
                      }))
                    }
                    isLoading={this.state.loadingEmpCategories}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row> */}

              {/* Nik */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  NIK<span className="text-danger"> *</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_nik"
                    placeholder="Masukkan NIK"
                    errorMessage="Masukkan NIK"
                    type="number"
                    className="form-control"
                    value={this.state.employeeOption?.nik}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Nik wajib diisi",
                      },
                      pattern: {
                        value: "^[0-9]{16}$",
                        errorMessage: "NIK harus 16 digit angka",
                      },
                    }}
                  />
                </Col>
              </Row>

              {/* No Kk */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Nomor Kartu Keluarga<span className="text-danger"> *</span>
                </Label>
                <Col md="5">
                  <AvField
                    name="cpns_candidate_nokk"
                    placeholder="Masukkan No Kartu Keluarga"
                    errorMessage="Masukkan No Kartu Keluarga"
                    type="number"
                    className="form-control"
                    value={this.state.employeeOption?.nokk}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Nomor kartu keluarga wajib diisi",
                      },
                      pattern: {
                        value: "^[0-9]{16}$",
                        errorMessage:
                          "Nomor kartu keluarga harus 16 digit angka",
                      },
                    }}
                  />
                </Col>
              </Row>

              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => {
                    this.props.toggle();
                    this.props.setDetailUuid("");
                  }}
                >
                  Cancel
                </Button>{" "}
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </ModalFooter>
            </AvForm>
          </ModalBody>
        </Modal>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin data tersebut sudah benar?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
      </Fragment>
    );
  }
}

export default withRouter(CreateModal);
